import { getProductStyleSearchString } from "@sellar-io/common";

export type FilterStyleChild = {
  searchValue: string;
  displayValue: string;
};

export type FilterStyle<StyleKey extends string = string> = {
  [key in StyleKey]: {
    key: StyleKey;
    searchValue: string | undefined;
    displayValue: string;
    children?: FilterStyleChild[];
  };
};

export type FilterCategoryKey = keyof typeof filterStyles;

export const filterStyles = {
  beer: {
    key: "beer",
    displayValue: "Beer",
    searchValue: getProductStyleSearchString("beer"),
    children: [
      {
        displayValue: "Lager",
        searchValue: "lager",
      },
      {
        displayValue: "Pale",
        searchValue: "pale",
      },
      {
        displayValue: "IPA",
        searchValue: "ipa",
      },
      {
        displayValue: "West Coast",
        searchValue: "west coast",
      },
      {
        displayValue: "NEIPA",
        searchValue: "neipa",
      },
      { displayValue: "Session", searchValue: "session" },
      { displayValue: "Table", searchValue: "table" },
      { displayValue: "Sour", searchValue: "sour" },
      { displayValue: "Stout", searchValue: "stout" },
      { displayValue: "Porter", searchValue: "porter" },
      { displayValue: "Fruited", searchValue: "fruited" },
      { displayValue: "Mixed fermentation", searchValue: "mixed fermentation" },
      { displayValue: "German", searchValue: "german" },
      { displayValue: "Belgian", searchValue: "belgian" },
      { displayValue: "Weissbier", searchValue: "weissbier" },
      { displayValue: "Berlinerweisse", searchValue: "berlinerweisse" },
      { displayValue: "Hefeweizen", searchValue: "hefeweizen" },
      { displayValue: "Radler", searchValue: "radler" },
      { displayValue: "Bitter", searchValue: "bitter" },
      { displayValue: "Mild", searchValue: "mild" },
    ],
  },
  cider: {
    key: "cider",
    displayValue: "Cider",
    searchValue: getProductStyleSearchString("cider"),
    children: [
      {
        displayValue: "Medium",
        searchValue: "medium",
      },
      {
        displayValue: "Sweet",
        searchValue: "sweet",
      },
      {
        displayValue: "Dry",
        searchValue: "dry",
      },
      {
        displayValue: "Cloudy",
        searchValue: "cloudy",
      },
      { displayValue: "Still", searchValue: "still" },
      { displayValue: "Sparkling", searchValue: "sparkling" },
      { displayValue: "Fruited", searchValue: "fruited" },
    ],
  },
  spirits: {
    key: "spirits",
    searchValue: getProductStyleSearchString("spirits"),
    displayValue: "Spirits",
    children: [
      {
        displayValue: "Gin",
        searchValue: "gin",
      },
      {
        displayValue: "Rum",
        searchValue: "rum",
      },
      {
        displayValue: "Vodka",
        searchValue: "vodka",
      },
      {
        displayValue: "RTD",
        searchValue: "rtd",
      },
      {
        displayValue: "Cocktails",
        searchValue: "cocktails",
      },
    ],
  },
  softDrinks: {
    key: "softDrinks",
    searchValue: getProductStyleSearchString("softDrinks"),
    displayValue: "Soft Drinks",
    children: [
      {
        displayValue: "Soda",
        searchValue: "soda",
      },
      { displayValue: "Kombucha", searchValue: "kombucha" },
      { displayValue: "Juice", searchValue: "juice" },
    ],
  },
  wine: {
    key: "wine",
    searchValue: getProductStyleSearchString("wine"),
    displayValue: "Wine",
    children: [
      { displayValue: "White wine", searchValue: "white" },
      { displayValue: "Red wine", searchValue: "red" },
      { displayValue: "Rosé wine", searchValue: "rosé" },
      { displayValue: "Sparkling wine", searchValue: "sparkling" },
    ],
  },
  mead: {
    key: "mead",
    searchValue: getProductStyleSearchString("mead"),
    displayValue: "Mead",
  },
} as const satisfies FilterStyle;
